import {Component, Input, OnChanges} from '@angular/core';
import {RefDetailComponent} from "./ref_detail.component";
import {FilterParams} from "app/models/filter_form.model";
import merge from "lodash-es/merge";
import {RefService} from "./ref.service";
import {StatsRefs} from "./ref.model";
import {HelperService} from "app/lib/helper.service";
import {ModalService} from "../modal/base_modal.component";

import dictionary from "dict/static.json";
import { FilterFormService } from "../filter_form/filter_form.service";
import { ActivatedRoute } from "@angular/router";

@Component({
	selector: 'refs',
	templateUrl: './ref.component.html',
})
export class RefComponent implements OnChanges {
	dictionary: any;
	
	@Input() public stats;
	@Input() public filterParams: FilterParams;
	@Input() public currentUrl: string;
	
	isDesc: boolean = false;
	direction: number = -1;
	column: string;
	
	refLoader: boolean = false;
	itemLoader: boolean[] = [];

	refererType: string = 'first';
	currencyType: string = 'all';
	
	dateType: string = 'dateCreated';
	
	Math: any;

	constructor(
		private refService: RefService,
		private modalService: ModalService,
		private helper: HelperService,
		public filter: FilterFormService,
		private activatedRoute: ActivatedRoute,
	) {
		this.Math = Math;
		this.dictionary = dictionary;

		this.activatedRoute.queryParams.subscribe(() => {
			const {
				refererType,
				refExtendedFilters,
				refererFilterType,
			} = this.filter.filterParams;
			
			
			if (
				refererFilterType === 'extended' &&
				refExtendedFilters[0] &&
				this.refererType !== refExtendedFilters[0].refererType
			) {
				this.refererType = refExtendedFilters[0].refererType;
			} else if (this.refererType !== refererType) {
				this.refererType = this.filter.filterParams.refererType;
			}
		});
	}

	get currencyList() { return this.dictionary.currencyList }

	async ngOnChanges(changes) {
		if (changes.stats) {
			if (this.filterParams.isRegDay) {
				this.column = 'countReg';
			} else if (this.filterParams.isBilling) {
				this.column = 'moneyCount';
			} else if (this.filterParams.isDomainBilling) {
				this.column = 'userCount';
			}

			if (this.filterParams.isBilling || this.filterParams.isDomainBilling) {
				this.dateType = 'datePaid';
			} else if (this.filterParams.isRegDay) {
				this.dateType = 'dateCreated';
			}

			// ПРОБЛЕМА: В таком варианте список рефереров по всем дням грузится почти одновременно (параллельно). А хотелось бы последовательно. - Vlad Sergeev.
			await this.getReferers();
		}
	}

	async getReferers() {
		this.refLoader  = true;
		
		this.stats.refs = await this.refService.getRefs(this.filterParams, {
			groupDate: this.stats.groupDate,
			dateType: this.dateType,
			currencyType: this.currencyType,
			refererType: this.refererType,
		}).toPromise();

		this.refLoader  = false;
	}

	sort(property: string) {
		// Удалить из массива подгруппы
		this.stats.refs = this.stats.refs.filter(function(groupRef) {
			return !groupRef.subGroup;
		});
		
		// Закрыть раскрытые группы при сортировке
		this.stats.refs.forEach(function (ref) {
			ref.opened = false;
		});
		
		this.isDesc = !this.isDesc; //change the direction
		this.column = property;
		this.direction = this.isDesc ? 1 : -1;
	}

	async showRefExpand(ref: StatsRefs, refIndex: number) {
		if ( ! ref.isGroup || ref.refGroup) return true;
		
		if ( ! ref.opened) {
			ref.opened = true;
			
			let me = this,
				groupRefs: StatsRefs[];
			
			if ( ! ref.subRefs) ref.subRefs = 0;
			
			this.itemLoader[refIndex] = true;
			
			groupRefs = await this.refService.getRefs(this.filterParams, {
				groupDate: this.stats.groupDate,
				inGroup: ref.ref,
				dateType: this.dateType,
				currencyType: this.currencyType,
				refererType: this.refererType,
				isGroup: ref.isGroup,
			}).toPromise();
			
			groupRefs.forEach(function(groupRef, i) {
				ref.subRefs++;
				groupRef.isGroup = false;
				groupRef.refGroup = ref.ref;
				groupRef.subGroup = true;
				groupRef.refererType = me.refererType;
				groupRef.currencyType = me.currencyType;
				
				me.stats.refs.splice(refIndex + 1 + i, 0, groupRef);
			});

			this.itemLoader[refIndex] = false;
		} else {
			ref.opened = false;
			
			this.stats.refs.splice(refIndex + 1, ref.subRefs);
		}
	}

	async showRefDetails(ref: StatsRefs, refIndex: number) {
		let details: any,
			reportType: string,
			refGroup: string,
			refSource: string;
		
		if (this.filterParams.isRegDay) {
			reportType = 'reg_day';
		} else if (this.filterParams.isBilling) {
			reportType = 'billing';
		} else if (this.filterParams.isDomainBilling) {
			reportType = 'domain';
		}
		
		if (ref.ref == 'Direct' || ref.ref == 'Referral' || ref.ref == 'Ungrouped') {
			refGroup  = ref.ref;
		} else {
			refGroup  = ref.refGroup;
			refSource = ref.ref;
		}
		
		let params = merge({}, this.filterParams, {
			dateTime: this.stats.groupDate,
			reportType: reportType,
			refGroup: refGroup,
			refSource: refSource,
			refererType: this.refererType
		});

		this.itemLoader[refIndex] = true;
		details = await this.refService.getRefDetails(params).toPromise();
		this.itemLoader[refIndex] = false;

		this.modalService.open(RefDetailComponent, {
			title: (refSource && refSource !== 'all') ? (refGroup + ' - ' + refSource) : (refGroup),
			stats: details
		}, { size: 'hg' });
	}
}
